import React from "react";
import { Switch, Route } from "react-router";
import ModulePage from "../modules/ModulePage";
import ActivityPage from "../activities/ActivityPage";
import Story from "../pages/Story";
import KeyTermsPage from "../keyterms/KeyTermsPage";
import SingleTermPage from "../keyterms/SingleTermPage";
import GoodQuestions from "../pages/GoodQuestions";
import ToolsAndTemplates from "../pages/ToolsAndTemplates";
import GenericPage from "../pages/GenericPage";
import Footer from "./Footer";
import Orientation from "../activities/Orientation";
import BadgesPage from "../pages/BadgesPage";
import DonePage from "../pages/DonePage";
import NotFound from "../pages/NotFound";

const MainSection = () => {
  return (
    <div className="relative flex flex-col w-full">
      <Switch>
        <Route path="/app" exact component={ModulePage} />
        <Route path="/app/pages/:contentKey" exact>
          <GenericPage />
        </Route>
        <Route path="/app/story" exact component={Story} />
        <Route path="/app/earn-badges" exact component={BadgesPage} />
        <Route path="/app/good-questions" exact component={GoodQuestions} />
        <Route
          path="/app/tools-and-templates"
          exact
          component={ToolsAndTemplates}
        />
        <Route path="/app/congratulations" exact component={DonePage} />

        <Route path="/app/key-terms" exact component={KeyTermsPage} />
        <Route path="/app/key-terms/:id" exact component={SingleTermPage} />

        <Route path="/app/orientation" exact component={Orientation} />
        <Route
          path="/app/activity/:activityId"
          exact
          component={ActivityPage}
        />
        <Route path="/app/:moduleId" exact component={ModulePage} />
        <Route path="/app/:moduleId/:topicId" exact component={ModulePage} />
        <Route
          path="/app/:moduleId/:topicId/:partIndex"
          exact
          component={ModulePage}
        />
      </Switch>

      <Footer />
    </div>
  );
};

export default MainSection;
